export enum TicketOrderErrorEnum {
  ORDER_NOT_DELETABLE = "ORDER_NOT_DELETABLE",
  PAYMENT_FAILED = "PAYMENT_FAILED",
  PAYMENT_FAILED_REFUNDED = "PAYMENT_FAILED_REFUNDED"
}
